import route from "./modules/route";
const base = window.__POWERED_BY_QIANKUN__ ? "/portal/ResourceManagementCenter/" : "/"
let arr = route.map(item => {
  return {
    ...item,
    path: base + item.path
  }
})
const coustom = window.__POWERED_BY_QIANKUN__
  ? arr
  : [
      {
        path: "/",
        name: "index",
        meta: {
          title: "首页",
          keepAlive: true,
        },
        redirect: "/sub",
      },
      {
        path: "/sub",
        name: "sub",

        component: () => import("@/views/sub.vue"),
        meta: {
          title: "子系统",
          keepAlive: true,
        },
        children: [...route],
      },
    ];
const routes = [...coustom,
  {
    path: '/:pathMatch(.*)*',
    component: () => import("@/views/NotFound.vue"),
  },
];

export default routes;
